import React, { useEffect, useState } from 'react';
import {
    Box,
    Flex,
    Text,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    SimpleGrid,
    BoxProps,
} from '@chakra-ui/react';

interface TabContent {
    tabTitle?: string;
    tabName: string;
    content: JSX.Element;
    imgUrl?: string;
    list?: { item: string; href?: string }[];
}

interface ExtendedTabsSectionProps extends BoxProps {
    title?: string;
    subtitle?: string;
    styles?: string;
    withAdding?: Boolean;
    tabsContent: TabContent[];
    activeTab?: string; // Dodane pole dla aktywnej zakładki
    onTabChange?: (tabName: string) => void; // Funkcja wywoływana przy zmianie zakładki
}

const ExtendedTabsSection: React.FC<ExtendedTabsSectionProps> = ({
    title,
    subtitle,
    styles,
    withAdding,
    tabsContent,
    activeTab,
    onTabChange,
    ...rest
}) => {
    const [selectedTab, setSelectedTab] = useState(
        activeTab ? tabsContent.findIndex(tab => tab.tabName === activeTab) : 0,
    );

    useEffect(() => {
        if (activeTab) {
            const tabIndex = tabsContent.findIndex(tab => tab.tabName === activeTab);
            setSelectedTab(tabIndex !== -1 ? tabIndex : 0);
        }
    }, [activeTab, tabsContent]);

    const handleTabChange = (index: number) => {
        setSelectedTab(index);
        if (onTabChange) {
            onTabChange(tabsContent[index].tabName);
        }
    };

    return (
        <Box {...rest}>
            <Flex pb={4} alignItems="center" flexDirection="column" className="text-main">
                <Text textAlign="center" fontSize="30px" as="b" className="text-wrapper">
                    {title}
                </Text>
                <Text mt={2} textAlign="center" fontSize="lg">
                    {subtitle}
                </Text>
            </Flex>
            <Tabs
                isFitted={styles !== 'centeredWithSpace'}
                variant="line"
                colorScheme="teal"
                mt={4}
                w="100%"
                index={selectedTab}
                onChange={handleTabChange}
                borderBottom={'none'}
                justifyContent={'center'}
            >
                <TabList
                    borderBottom={'none'}
                    justifyContent={'center'}
                    overflowX={'auto'}
                    overflowY={'hidden'}
                    padding={'30px 0 50px 0'}
                >
                    {tabsContent.map((tab, index) =>
                        index === 0 && styles === 'centeredWithSpace' ? (
                            <>
                                <Tab
                                    key={index}
                                    _selected={{
                                        color: 'black',
                                        borderBottom: '4px solid #1AAC7A',
                                        outline: 'none',
                                        fontWeight: 'bold',
                                    }}
                                    _focus={{ outline: 'none' }}
                                    whiteSpace={'nowrap'}
                                    pb={2}
                                >
                                    {tab.tabName}
                                </Tab>
                                {withAdding === true ?? (
                                    <Flex alignItems={'center'} justifyContent={'center'}>
                                        lub
                                    </Flex>
                                )}
                            </>
                        ) : (
                            <Tab
                                key={index}
                                _selected={{
                                    color: 'black',
                                    borderBottom: '4px solid #1AAC7A',
                                    outline: 'none',
                                    fontWeight: 'bold',
                                }}
                                _focus={{ outline: 'none' }}
                                whiteSpace={'nowrap'}
                                pb={2}
                            >
                                {tab.tabName}
                            </Tab>
                        ),
                    )}
                </TabList>
                <TabPanels className="frame-2">
                    {tabsContent.map((tab, index) => (
                        <TabPanel key={index} className="frame-3" mt={0} paddingTop={'0'}>
                            <SimpleGrid
                                templateColumns="repeat(1, 1fr)"
                                gap="30px"
                                gridTemplateColumns={{
                                    sm: 'templateColumns="1fr"',
                                    lg: 'repeat(1, 1fr)',
                                }}
                            >
                                {tab.content}
                            </SimpleGrid>
                        </TabPanel>
                    ))}
                </TabPanels>
            </Tabs>
        </Box>
    );
};

export default ExtendedTabsSection;
